import swal from "sweetalert";

export type WarningDialogProps = {
  title: string;
  content?: string;
}
export const WarningDialog = (props: WarningDialogProps) => {
  swal(props.title, props.content ? props.content : "", "warning");
}